// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/**
 * Create and attach devices for a specific backend.
 */
export class Adapter {
}
//# sourceMappingURL=adapter.js.map